// extracted by mini-css-extract-plugin
export default {"qualityChecksContainer":"quality-checks-container__quality-checks-container__V_kar","cogIcon":"quality-checks-container__cog-icon__VjmWI"};